import React, {createRef, ReactElement} from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {classNames} from 'react-select/src/utils';
import closeIcon from '../../assets/images/cross-icon.svg';
import {makeid} from '../../core/utils/string.util';
import useWindowDimensions from '../../core/utils/window.utils';

export enum ModalAnimateDirection {
  BOTTOM_TO_TOP,
  RIGHT_TO_LEFT,
}

type ModalProps = {
  children?: React.ReactNode;
  isVisible?: boolean;
  onClose?: () => void;
  animate?: boolean;
  animateDirection?: ModalAnimateDirection;
  classNames?: string;
};

const CustomModal = ({
  children,
  onClose,
  isVisible,
  animate,
  animateDirection,
  classNames,
}: ModalProps): ReactElement => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const {width} = useWindowDimensions();
  const [modalAnimateClasses, setModalAnimateClasses] = useState<string>('');
  const scrollerRef = createRef();

  const modalId = `msm_${makeid(6)}_${makeid(3)}`;

  useEffect(() => {
    if (scrollerRef.current) {
      const _el = scrollerRef.current as HTMLDivElement;
      const height = _el.scrollHeight;
      console.log('height is ', height);
    }
  }, []);

  useEffect(() => {
    console.log(width);
    if (animate && animateDirection) {
      if (isVisible) {
        setModalAnimateClasses(
          'animate__animated animate__zoomIn animate__faster',
        );
        setShowModal(true);
      } else {
        setModalAnimateClasses(
          'animate__animated animate__zoomOut animate__faster',
        );
        setTimeout(() => {
          setShowModal(false);
        }, 500);
      }
    } else {
      setShowModal(isVisible || false);
    }
  }, [isVisible]);
  return (
    <React.Fragment>
      {showModal && (
        <div
          className={`fixed inset-0 ${
            location.pathname === '/home/todaysorder' ? 'z-40' : 'z-50'
          } h-full`}>
          <div className="flex items-center justify-center min-h-screen text-center h-full">
            <div className="fixed inset-0 trasition-opacity" onClick={onClose}>
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            </div>
            <div
              ref={scrollerRef as React.RefObject<HTMLDivElement>}
              className={`absolute max-h-full z-50 bottom-0 left-0 right-0 inline-block bg-white custom-modal-wrapper w-full h-auto rounded-t-3xl ${modalAnimateClasses} ${classNames}`}
              id={modalId}
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline">
              <div className="absolute -top-16 right-4 cross-icon">
                <img src={closeIcon} onClick={onClose} />
              </div>
              <div className="modal-handle bg-light_gray opacity-50 rounded ml-auto mr-auto mt-2 mb-4">
                &nbsp;
              </div>
              {children}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CustomModal;
